import React, {useRef, useState, useEffect} from 'react';
import {
    INITIAL_VALUE,
    ReactSVGPanZoom,
    TOOL_NONE,
    fitSelection,
    zoomOnViewerCenter,
    fitToViewer,
    UncontrolledReactSVGPanZoom, TOOL_PAN, TOOL_AUTO
} from 'react-svg-pan-zoom';
import {Square} from "react-svg-path";

const SvgMap2 = () => {
    const Viewer = useRef(null);
    const [tool, setTool] = useState(TOOL_AUTO)
    const [value, setValue] = useState(INITIAL_VALUE)

    useEffect(() => {
        Viewer.current.fitToViewer();
    }, []);

    /* Read all the available methods in the documentation */
    const _zoomOnViewerCenter1 = () => Viewer.current.zoomOnViewerCenter(1.1)
    const _zoomOnViewerCenter11 = () => Viewer.current.zoomOnViewerCenter(0.9)
    const _fitSelection1 = () => Viewer.current.fitSelection(40, 40, 200, 200)
    const _fitToViewer1 = () => Viewer.current.fitToViewer()

    /* keep attention! handling the state in the following way doesn't fire onZoom and onPam hooks */
    const _zoomOnViewerCenter2 = () => setValue(zoomOnViewerCenter(value, 0.1))
    const _fitSelection2 = () => setValue(fitSelection(value, 40, 40, 200, 200))
    const _fitToViewer2 = () => setValue(fitToViewer(value))

    // console.log('value', value)
    // console.log('tool', tool)

    return (
        <div>


            <button className="btn__plus" onClick={() => _zoomOnViewerCenter1()}>+</button>
            <button className="btn__minus" onClick={() => _zoomOnViewerCenter11()}>-</button>
            {/*<button className="btn" onClick={() => _fitSelection1()}>Zoom area 200x200 (mode 1)</button>*/}
            {/*<button className="btn" onClick={() => _fitToViewer1()}>Fit (mode 1)</button>*/}
            {/*<hr/>*/}

            {/*<button className="btn" onClick={() => _zoomOnViewerCenter2()}>Zoom on center (mode 2)</button>*/}
            {/*<button className="btn" onClick={() => _fitSelection2()}>Zoom area 200x200 (mode 2)</button>*/}
            {/*<button className="btn" onClick={() => _fitToViewer2()}>Fit (mode 2)</button>*/}
            {/*<hr/>*/}

            <ReactSVGPanZoom
                ref={Viewer}
                width={1920} height={980}
                tool={tool}
                onChangeTool={setTool}
                value={value}
                onChangeValue={setValue}
                // onZoom={e => console.log('zoom', e)}
                // onPan={e => console.log('pan', e)}
                onClick={event => console.log('click', event.x, event.y, event.originalEvent)}
                // scaleFactorMin={0.01}
                miniatureProps={{position: 'right', width: 200, height: 100}}
                SVGBackground={'#152C31'}
                // preventPanOutside={false}
                // style={{fill:'red'}}
                // SVGStyle={{fill:'red'}}
                detectAutoPan={false}
                scaleFactorMin={0.01}
                scaleFactorMax={1}
            >
                <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
                     width="9690.000000pt" height="13700.000000pt" viewBox="0 0 9690.000000 13700.000000"
                     preserveAspectRatio="xMidYMid meet">

                    <g transform="translate(0.000000,13700.000000) scale(0.100000,-0.100000)"
                       fill="#12181D" stroke="none">


                        <path d="M67625 120425 c-155 -24 -304 -88 -436 -187 -103 -77 -147 -124 -277
-299 -55 -74 -137 -170 -182 -212 -382 -360 -898 -477 -1389 -315 l-93 31 -87
-42 c-392 -193 -723 -464 -996 -816 -119 -152 -212 -306 -310 -508 -155 -320
-249 -654 -291 -1032 -21 -185 -24 -541 -6 -675 18 -133 17 -347 -3 -440 -34
-162 -109 -311 -231 -459 -82 -98 -100 -174 -68 -280 30 -101 134 -181 235
-181 50 0 54 -2 134 -75 158 -143 392 -423 532 -637 170 -259 339 -651 413
-958 11 -47 25 -103 30 -125 26 -108 60 -358 69 -510 15 -242 -4 -540 -49
-760 -44 -219 -62 -286 -128 -474 l-47 -135 -95 -75 c-119 -95 -431 -354 -530
-441 -41 -36 -97 -83 -124 -105 -292 -232 -1244 -1134 -1634 -1548 -215 -228
-432 -432 -581 -546 -531 -406 -1137 -656 -1805 -747 -135 -18 -216 -40 -278
-77 -65 -38 -145 -128 -181 -204 -27 -59 -32 -81 -35 -168 -3 -82 1 -119 22
-205 130 -535 -48 -1085 -471 -1450 -253 -218 -367 -337 -516 -538 -200 -270
-422 -723 -555 -1132 -151 -463 -214 -849 -232 -1430 -10 -320 -17 -371 -76
-549 -84 -252 -239 -475 -448 -644 -374 -302 -656 -712 -805 -1171 -57 -176
-128 -289 -242 -386 -249 -214 -295 -291 -354 -590 -56 -286 -265 -535 -538
-640 -40 -16 -122 -38 -182 -50 -208 -41 -333 -107 -457 -239 -61 -66 -81 -98
-151 -241 -117 -242 -185 -345 -318 -485 -145 -152 -218 -182 -474 -196 -228
-12 -310 -22 -463 -60 -459 -113 -858 -395 -1115 -789 -31 -47 -62 -94 -70
-105 -8 -12 -50 -32 -103 -49 -146 -47 -438 -158 -635 -242 -227 -97 -663
-313 -866 -431 l-153 -88 -64 -95 c-286 -420 -728 -677 -1242 -721 -199 -17
-385 5 -621 73 -91 26 -120 30 -188 26 -180 -9 -327 -132 -366 -305 -10 -43
-60 -106 -482 -603 -283 -332 -496 -574 -532 -603 -68 -55 -209 -126 -305
-153 -99 -29 -318 -27 -423 4 -148 42 -239 97 -418 250 -41 35 -190 157 -331
272 l-257 210 -445 162 -445 161 -281 -43 -281 -44 -452 -580 -452 -580 -700
-756 c-385 -416 -747 -809 -804 -873 -289 -326 -580 -521 -944 -631 -412 -125
-827 -107 -1257 54 -155 58 -264 31 -324 -79 -14 -27 -26 -54 -26 -61 0 -20
-108 -177 -187 -271 -224 -267 -528 -473 -856 -580 -319 -104 -651 -144 -962
-118 -264 23 -345 16 -470 -41 -128 -58 -246 -173 -298 -290 -114 -259 -185
-377 -306 -503 -245 -256 -575 -397 -932 -397 -148 0 -271 21 -435 76 -72 24
-162 48 -200 54 -131 21 -297 -13 -423 -87 -88 -52 -198 -172 -244 -265 l-36
-73 -55 -1653 -55 -1654 -198 -304 -198 -304 -385 -217 c-448 -251 -497 -282
-605 -374 -243 -205 -412 -499 -475 -826 -49 -256 -213 -727 -378 -1088 -30
-66 -132 -273 -227 -460 -215 -425 -290 -614 -370 -935 -132 -524 -148 -872
-76 -1740 45 -547 110 -1207 196 -1982 37 -327 55 -534 55 -615 0 -152 -21
-318 -60 -465 -28 -110 -44 -158 -184 -546 -113 -313 -269 -834 -341 -1137
-109 -462 -181 -909 -225 -1405 -33 -377 -65 -581 -130 -840 -126 -500 -366
-1019 -665 -1436 -105 -145 -129 -194 -152 -304 -20 -96 -13 -164 34 -315 34
-113 37 -128 37 -260 0 -119 -3 -151 -23 -215 -40 -130 -85 -206 -206 -350
-83 -99 -105 -133 -137 -215 -21 -56 -23 -70 -18 -210 3 -82 4 -238 4 -345 -1
-176 -4 -206 -28 -305 -54 -222 -106 -351 -215 -535 -66 -111 -101 -212 -108
-314 -10 -151 16 -248 117 -429 62 -112 112 -225 148 -337 54 -164 82 -426 63
-594 -16 -140 -39 -255 -56 -282 -10 -15 -47 -437 -126 -1449 -102 -1288 -112
-1435 -101 -1505 25 -172 90 -300 218 -427 45 -46 87 -83 93 -83 6 0 11 -4 11
-10 0 -5 7 -10 15 -10 8 0 15 -4 15 -9 0 -13 105 -56 180 -74 36 -8 115 -18
177 -21 129 -7 268 -39 364 -85 36 -17 71 -31 77 -31 7 0 12 -4 12 -10 0 -5 9
-10 19 -10 10 0 33 -13 51 -30 18 -16 36 -30 40 -30 14 0 143 -135 180 -190
98 -144 376 -693 543 -1070 334 -756 563 -1475 762 -2400 37 -173 37 -446 0
-647 -15 -78 -20 -89 -98 -196 -456 -624 -712 -1363 -742 -2142 -8 -202 -21
-308 -57 -449 -68 -272 -191 -518 -372 -742 -68 -85 -240 -253 -286 -280 -18
-11 -45 -54 -84 -133 -472 -949 -1347 -1639 -2382 -1876 -225 -52 -346 -66
-604 -72 -189 -4 -277 -2 -384 11 -531 62 -1015 252 -1436 565 -107 80 -163
108 -239 120 -118 19 -226 -15 -314 -98 -74 -70 -109 -144 -115 -243 -2 -43 0
-97 6 -121 12 -45 182 -374 425 -821 143 -262 171 -332 160 -389 -19 -102
-107 -177 -207 -177 -54 0 -818 141 -881 162 -73 25 -206 28 -281 5 -152 -45
-241 -125 -349 -316 -93 -163 -150 -248 -256 -383 -91 -114 -315 -342 -425
-431 -71 -57 -72 -58 -246 -102 -1414 -359 -2898 -337 -4318 66 -58 16 -202
62 -321 101 l-217 70 -239 192 c-908 727 -1655 1397 -2513 2255 l-465 465
-195 48 c-701 173 -1450 295 -2200 358 -349 29 -707 41 -1245 41 -667 -1 -738
6 -972 89 -177 63 -304 137 -502 293 -149 117 -260 189 -374 242 -260 121
-477 169 -767 168 -358 0 -660 -93 -970 -299 -81 -54 -77 -38 -58 -236 19
-206 -10 -543 -68 -772 -77 -311 -157 -490 -397 -897 -335 -567 -709 -1119
-1176 -1732 -91 -120 -167 -221 -168 -225 -2 -4 1 -14 7 -22 7 -12 40 -14 182
-14 95 1 202 4 238 8 36 3 79 6 97 6 17 0 34 4 38 10 4 6 16 8 26 5 11 -4 25
-2 32 3 13 11 103 27 130 23 9 -1 17 2 17 7 0 6 9 8 20 5 11 -3 20 -1 20 4 0
6 26 15 57 22 96 20 143 33 143 41 0 7 93 43 142 54 15 3 33 12 41 20 19 19
133 76 152 76 8 0 23 9 32 20 10 11 25 20 34 20 9 0 19 7 23 15 3 8 15 15 26
15 11 0 20 5 20 10 0 6 7 10 15 10 8 0 15 5 15 10 0 6 7 10 15 10 8 0 15 5 15
10 0 6 7 10 15 10 8 0 15 4 15 9 0 5 35 35 77 67 43 32 146 124 228 204 151
146 229 200 288 200 13 0 26 3 30 6 11 12 102 13 156 3 77 -16 191 -66 229
-102 19 -18 59 -69 90 -114 59 -85 160 -196 187 -206 8 -4 15 -11 15 -17 0 -5
7 -10 15 -10 8 0 15 -4 15 -9 0 -13 129 -69 200 -85 85 -20 258 -21 335 -1 78
20 165 55 165 66 0 5 6 9 14 9 8 0 34 11 57 25 105 60 272 91 397 74 72 -10
261 -72 272 -89 3 -4 21 -14 40 -22 20 -9 94 -73 166 -144 72 -71 165 -158
207 -193 42 -35 77 -68 77 -72 0 -5 7 -9 15 -9 9 0 18 -7 21 -15 4 -8 13 -15
20 -15 8 0 17 -7 20 -15 4 -8 12 -15 20 -15 8 0 14 -4 14 -10 0 -5 7 -10 15
-10 9 0 18 -7 21 -15 4 -8 12 -15 20 -15 8 0 14 -4 14 -10 0 -5 11 -12 25 -16
14 -3 25 -10 25 -15 0 -5 7 -9 15 -9 8 0 15 -4 15 -9 0 -5 10 -13 23 -17 12
-4 24 -10 27 -13 11 -14 60 -41 75 -41 8 0 15 -4 15 -8 0 -5 44 -30 98 -55
194 -91 389 -159 602 -208 118 -27 240 -69 347 -120 45 -21 87 -39 92 -39 6 0
11 -4 11 -10 0 -5 11 -12 25 -16 14 -3 25 -10 25 -15 0 -5 9 -9 19 -9 10 0 33
-13 51 -30 18 -16 36 -30 41 -30 5 0 12 -7 15 -15 4 -8 12 -15 19 -15 8 0 22
-11 33 -25 11 -14 24 -25 29 -25 17 0 168 -162 230 -247 34 -45 89 -133 123
-195 73 -133 123 -202 193 -266 28 -26 61 -57 74 -69 13 -13 28 -23 33 -23 4
0 10 -4 12 -9 5 -14 118 -67 183 -86 33 -9 112 -21 175 -25 98 -6 124 -11 175
-36 33 -16 66 -35 73 -41 7 -7 20 -13 28 -13 8 0 14 -4 14 -10 0 -5 7 -10 15
-10 8 0 15 -4 15 -10 0 -5 7 -10 15 -10 9 0 18 -7 21 -15 4 -8 12 -15 19 -15
23 0 163 -140 230 -228 148 -198 230 -431 242 -688 8 -175 -19 -342 -83 -500
l-24 -61 191 -334 c105 -184 461 -831 791 -1439 330 -608 618 -1136 640 -1175
53 -90 136 -171 192 -186 22 -6 127 -53 233 -104 390 -192 706 -311 1083 -409
397 -104 727 -151 1214 -176 428 -22 639 -75 1019 -257 307 -147 529 -211 801
-233 477 -39 1012 -217 1367 -456 53 -36 122 -74 153 -84 68 -24 164 -26 273
-5 176 34 330 13 493 -67 91 -44 117 -63 191 -137 47 -47 129 -147 181 -222
296 -418 663 -783 1064 -1055 63 -43 114 -81 114 -86 0 -4 9 -8 20 -8 11 0 23
-7 26 -15 4 -8 12 -15 20 -15 8 0 14 -4 14 -9 0 -5 10 -13 22 -17 12 -3 28
-13 36 -20 7 -8 22 -14 32 -14 11 0 23 -6 27 -14 10 -16 66 -46 87 -46 8 0 26
-10 40 -23 27 -25 83 -52 128 -61 15 -3 33 -12 40 -19 20 -21 54 -37 77 -37
10 0 21 -5 23 -11 2 -5 19 -14 38 -19 19 -4 80 -22 135 -39 150 -48 254 -65
390 -64 175 1 183 2 190 12 3 6 12 8 19 5 41 -16 368 103 389 141 4 8 17 15
27 15 11 0 20 5 20 10 0 6 7 10 15 10 8 0 15 5 15 10 0 6 7 10 15 10 8 0 15 4
15 8 0 10 113 102 150 123 14 8 29 20 33 26 4 7 15 13 22 13 8 0 15 5 15 10 0
6 7 10 15 10 8 0 15 5 15 10 0 6 6 10 14 10 8 0 21 6 28 14 8 7 24 17 36 20
12 4 22 12 22 17 0 5 5 9 11 9 5 0 49 18 96 41 108 51 294 113 404 133 200 38
456 38 616 1 46 -11 76 -12 115 -5 29 5 199 30 378 54 1698 234 3342 337 5080
318 736 -7 1102 22 1664 133 244 49 321 57 496 57 244 0 435 -31 665 -107 127
-41 385 -156 413 -182 7 -7 20 -13 28 -13 8 0 14 -4 14 -10 0 -5 11 -12 25
-16 14 -3 25 -10 25 -15 0 -5 7 -9 15 -9 9 0 18 -7 21 -15 4 -8 12 -15 20 -15
8 0 14 -4 14 -10 0 -5 7 -10 15 -10 9 0 27 -11 41 -25 14 -14 29 -25 35 -25 5
0 12 -7 15 -15 4 -8 13 -15 20 -15 8 0 17 -7 20 -15 4 -8 12 -15 20 -15 8 0
19 -9 26 -20 7 -11 18 -20 23 -20 28 0 264 -223 505 -478 74 -78 140 -142 146
-142 7 0 14 -7 18 -15 3 -8 13 -15 21 -15 9 0 23 -6 30 -14 7 -7 53 -26 102
-42 78 -26 102 -29 213 -29 75 0 139 5 160 13 31 11 104 5 545 -43 729 -78
1499 -149 2172 -199 322 -24 587 -46 590 -49 3 -3 -1268 -2210 -2824 -4904
l-2828 -4898 -375 -3 -375 -2 -88 -156 c-49 -85 -92 -154 -96 -152 -34 14
-591 342 -591 348 0 4 35 28 78 52 690 403 1027 1279 781 2029 -75 229 -173
394 -369 620 -140 161 -197 313 -187 494 3 54 14 116 28 155 22 64 22 76 26
680 6 807 -23 1564 -69 1785 -53 260 -212 449 -447 531 -127 44 -198 47 -451
19 -515 -56 -994 -86 -1400 -89 -336 -1 -344 0 -505 82 -71 37 -108 64 -175
132 -47 47 -100 113 -120 147 -19 34 -51 91 -70 125 -45 80 -187 224 -265 269
-134 78 -280 118 -421 119 -115 0 -265 16 -434 46 -512 92 -994 318 -1398 656
-187 157 -542 280 -887 308 -149 11 -562 -8 -745 -36 -578 -86 -1087 -321
-1536 -708 -105 -90 -284 -271 -284 -287 0 -23 583 -2154 603 -2204 66 -169
198 -290 372 -341 88 -26 215 -22 344 10 487 121 974 -14 1327 -368 192 -192
298 -379 370 -651 23 -87 27 -126 31 -295 5 -172 3 -210 -16 -309 -42 -217
-125 -418 -246 -596 -140 -205 -157 -232 -200 -321 -56 -114 -107 -269 -131
-399 -28 -146 -26 -423 4 -561 30 -138 64 -240 123 -364 230 -483 681 -799
1302 -912 164 -30 525 -33 688 -5 547 92 1026 371 1362 794 87 110 142 145
255 165 59 10 79 9 138 -5 82 -21 163 -71 202 -126 15 -22 50 -73 77 -113 69
-100 290 -319 405 -401 117 -83 342 -195 475 -237 350 -110 679 -115 1036 -14
l127 35 348 -201 c192 -111 353 -205 357 -209 5 -5 -30 -74 -77 -154 -47 -80
-86 -151 -86 -156 0 -5 85 -158 190 -340 104 -181 190 -334 190 -340 0 -9
-1725 -3008 -1740 -3024 -5 -6 -1190 1639 -1324 1839 -39 57 -122 139 -176
174 -82 53 -154 73 -272 78 -126 5 -204 -14 -303 -73 -81 -49 -115 -83 -196
-197 -234 -328 -490 -607 -785 -855 -143 -120 -167 -147 -208 -233 -26 -55
-31 -80 -34 -160 -4 -86 -1 -103 26 -176 24 -67 32 -110 42 -238 7 -86 10
-159 7 -162 -5 -5 -3000 1716 -3020 1735 -4 4 -1 66 8 137 37 302 28 878 -16
1054 -110 440 -585 684 -1019 524 l-65 -25 -222 -332 c-346 -520 -609 -938
-938 -1492 -251 -424 -304 -503 -457 -677 -497 -570 -1172 -921 -1943 -1009
-127 -15 -482 -15 -600 0 -414 52 -833 84 -1110 85 l-230 1 -51 -28 c-100 -56
-158 -137 -222 -313 -55 -149 -67 -222 -67 -419 0 -164 3 -190 28 -288 29
-117 118 -309 185 -402 48 -67 162 -185 178 -185 7 0 22 26 34 57 37 99 71
152 144 221 194 184 450 222 692 102 86 -42 101 -55 299 -260 183 -188 364
-324 572 -429 606 -304 1328 -304 1913 1 288 150 502 334 725 623 248 322 581
596 925 762 96 46 293 125 341 136 18 5 45 35 90 99 354 506 620 1122 739
1711 17 83 32 153 35 155 3 3 3048 -1751 3065 -1765 11 -10 11 -542 0 -771
-14 -299 -34 -414 -89 -528 -67 -135 -186 -240 -329 -290 -72 -25 -251 -128
-377 -217 -246 -174 -485 -424 -658 -687 -89 -136 -225 -413 -277 -565 -51
-147 -93 -317 -116 -467 -20 -127 -26 -514 -10 -718 7 -94 5 -128 -8 -184 -61
-257 -296 -445 -557 -446 -73 0 -197 28 -256 58 -62 32 -156 107 -188 151 -24
32 -53 51 -145 95 -490 232 -1060 266 -1577 94 -213 -70 -450 -196 -623 -331
-172 -134 -327 -297 -398 -417 -51 -88 -170 -211 -260 -270 -327 -215 -743
-197 -1050 45 -75 59 -81 62 -222 98 -801 207 -1618 525 -2375 923 l-220 116
-225 33 c-396 58 -685 116 -1131 224 l-207 51 -58 -27 c-129 -59 -287 -201
-357 -322 -149 -254 -153 -521 -15 -940 220 -670 804 -1164 1508 -1275 52 -9
167 -20 255 -24 190 -11 247 -28 326 -100 78 -70 118 -139 138 -237 l17 -82
101 -108 c186 -197 505 -467 775 -654 630 -438 1381 -745 2130 -871 775 -130
1479 -98 2273 104 386 98 597 84 940 -62 246 -105 355 -128 564 -119 151 7
281 37 406 96 143 67 220 125 380 286 162 163 240 220 379 275 111 45 198 60
367 65 641 20 1214 247 1705 676 172 150 366 382 496 594 93 151 89 141 74
231 -27 153 -39 354 -33 559 18 620 203 1150 609 1742 225 329 537 685 815
928 138 121 266 169 440 164 l93 -3 74 51 c203 141 368 310 508 518 393 583
444 1326 134 1952 -58 117 -161 286 -197 323 -34 35 -223 305 -223 320 -1 8
399 709 888 1557 l889 1543 396 0 396 0 215 377 c118 207 216 382 218 389 2 7
-78 154 -177 327 -100 173 -181 320 -181 326 0 6 269 478 599 1049 2962 5131
5104 8839 5111 8846 18 19 512 -70 780 -140 268 -70 526 -154 771 -252 172
-69 1072 -467 1479 -654 576 -265 938 -438 1695 -809 426 -208 659 -317 720
-335 80 -24 107 -27 245 -28 178 -1 255 15 408 83 121 55 167 65 275 58 112
-6 180 -30 265 -95 106 -80 171 -188 193 -321 10 -61 34 -96 128 -189 155
-153 358 -260 583 -308 110 -23 323 -23 431 0 43 10 145 39 225 66 402 133
783 197 1247 210 311 9 387 19 558 76 101 33 226 89 241 108 6 7 23 16 38 20
15 3 33 12 40 20 8 7 24 17 36 20 12 4 22 12 22 17 0 5 5 9 11 9 5 0 48 18 95
40 409 196 880 226 1312 84 106 -34 335 -137 360 -161 7 -7 20 -13 28 -13 8 0
14 -4 14 -10 0 -5 7 -10 15 -10 8 0 15 -4 15 -10 0 -5 7 -10 15 -10 8 0 15 -4
15 -10 0 -5 11 -12 25 -16 14 -3 25 -10 25 -14 0 -13 112 -59 186 -76 52 -12
101 -15 199 -11 115 3 140 7 216 36 47 17 96 41 107 51 12 11 28 20 37 20 8 0
15 5 15 10 0 6 6 10 14 10 8 0 16 7 20 15 3 8 12 15 21 15 8 0 15 5 15 10 0 6
6 10 14 10 8 0 16 7 20 15 3 8 18 21 33 28 15 6 37 22 50 34 12 13 29 23 36
23 8 0 17 7 21 15 3 8 12 15 20 15 7 0 16 7 20 15 3 8 12 15 20 15 7 0 16 7
20 15 3 8 12 15 20 15 7 0 16 7 20 15 3 8 9 15 14 15 5 0 26 16 46 35 21 19
44 35 52 35 8 0 14 4 14 9 0 11 124 111 137 111 4 0 14 9 21 20 7 11 17 20 23
20 6 0 20 11 31 25 11 14 26 25 34 25 8 0 14 4 14 9 0 8 193 181 202 181 21 0
627 603 804 800 376 419 746 908 1026 1355 51 83 100 163 108 179 20 39 148
176 165 176 7 0 15 7 19 15 3 8 12 15 21 15 8 0 15 5 15 10 0 6 7 10 15 10 8
0 15 5 15 10 0 6 5 10 11 10 6 0 40 14 75 30 153 73 349 93 509 51 85 -23 233
-86 251 -108 6 -7 16 -13 23 -13 6 0 11 -4 11 -10 0 -5 11 -12 25 -16 14 -3
25 -10 25 -15 0 -5 7 -9 15 -9 8 0 15 -4 15 -10 0 -5 7 -10 15 -10 8 0 15 -4
15 -10 0 -5 11 -12 25 -16 14 -3 25 -10 25 -15 0 -5 7 -9 15 -9 8 0 15 -4 15
-10 0 -5 7 -10 15 -10 8 0 15 -4 15 -10 0 -5 11 -12 25 -16 14 -3 25 -10 25
-15 0 -5 7 -9 15 -9 8 0 15 -4 15 -10 0 -5 9 -10 20 -10 11 0 23 -7 26 -15 4
-8 12 -15 20 -15 8 0 14 -4 14 -10 0 -5 7 -10 15 -10 8 0 15 -4 15 -10 0 -5 9
-10 20 -10 11 0 23 -7 26 -15 4 -8 12 -15 20 -15 8 0 14 -4 14 -10 0 -5 7 -10
15 -10 8 0 15 -4 15 -10 0 -5 11 -12 25 -16 14 -3 25 -10 25 -15 0 -5 7 -9 15
-9 8 0 15 -4 15 -10 0 -5 7 -10 15 -10 8 0 15 -4 15 -10 0 -5 11 -12 25 -16
14 -3 25 -10 25 -15 0 -5 7 -9 15 -9 8 0 15 -4 15 -10 0 -5 7 -10 15 -10 8 0
15 -4 15 -10 0 -5 11 -12 25 -16 14 -3 25 -10 25 -15 0 -5 7 -9 15 -9 8 0 15
-4 15 -10 0 -5 9 -10 20 -10 11 0 23 -7 26 -15 4 -8 12 -15 20 -15 8 0 14 -4
14 -9 0 -5 10 -13 22 -17 12 -3 28 -13 36 -20 7 -8 20 -14 28 -14 8 0 14 -4
14 -10 0 -5 9 -10 20 -10 11 0 23 -7 26 -15 4 -8 12 -15 20 -15 8 0 14 -4 14
-10 0 -5 11 -12 25 -16 14 -3 25 -10 25 -14 0 -5 10 -12 22 -16 12 -3 28 -13
36 -20 7 -8 20 -14 28 -14 8 0 14 -4 14 -9 0 -5 10 -13 22 -17 12 -3 28 -13
36 -20 7 -8 20 -14 28 -14 8 0 14 -4 14 -10 0 -5 7 -10 15 -10 8 0 15 -4 15
-10 0 -5 11 -12 25 -16 14 -3 25 -10 25 -14 0 -5 10 -12 22 -16 12 -3 28 -13
36 -20 7 -8 20 -14 28 -14 8 0 14 -4 14 -9 0 -5 10 -13 22 -17 12 -3 28 -13
36 -20 7 -8 20 -14 28 -14 8 0 14 -4 14 -10 0 -5 9 -10 20 -10 11 0 23 -7 26
-15 4 -8 12 -15 20 -15 8 0 14 -4 14 -9 0 -5 10 -13 22 -17 12 -3 28 -13 36
-20 7 -8 20 -14 28 -14 8 0 14 -4 14 -8 0 -5 19 -17 43 -28 23 -10 48 -24 55
-31 7 -7 20 -13 28 -13 8 0 14 -4 14 -10 0 -5 7 -10 15 -10 8 0 15 -4 15 -10
0 -5 7 -10 15 -10 9 0 27 -11 41 -25 14 -14 29 -25 35 -25 5 0 12 -7 15 -15 4
-8 12 -15 20 -15 8 0 19 -9 26 -20 7 -11 18 -20 25 -20 6 0 40 -27 75 -60 34
-33 66 -60 69 -60 25 0 344 -372 355 -415 6 -22 202 -119 403 -200 854 -342
1821 -407 2717 -181 128 32 132 34 175 80 195 211 231 468 99 714 -17 31 -46
74 -65 95 -85 95 -58 209 56 238 27 7 49 18 49 25 0 28 447 557 729 864 270
293 945 949 987 958 8 2 14 8 14 13 0 10 258 238 280 247 8 3 23 16 33 29 10
13 23 23 29 23 5 0 19 11 30 25 11 14 23 25 27 25 4 0 29 20 55 45 27 25 54
45 60 45 6 0 17 9 24 20 7 11 18 20 25 20 7 0 18 9 25 20 7 11 19 20 27 20 8
0 15 4 15 10 0 5 25 28 55 51 63 48 116 114 141 179 30 80 143 238 233 328
177 178 357 280 621 351 415 113 762 313 1059 612 223 224 417 527 520 809
153 423 227 604 361 890 285 605 653 1191 1082 1722 170 211 233 262 367 302
61 18 184 21 250 5 61 -14 146 -56 187 -91 44 -39 174 -113 244 -139 174 -65
290 -76 556 -49 461 45 1197 143 1472 196 527 100 1000 347 1376 721 55 54
154 163 220 243 162 194 231 266 360 377 159 136 318 237 576 368 394 199 460
251 849 660 76 80 160 127 268 150 88 19 130 19 228 -1 108 -22 333 -22 451
-1 201 36 380 115 609 268 470 314 806 807 929 1361 13 62 37 210 51 328 50
411 127 689 275 996 56 115 62 123 132 179 111 88 173 151 247 250 276 370
386 661 416 1093 l7 93 -41 62 c-118 182 -168 400 -142 612 23 182 71 290 228
513 266 376 423 666 591 1087 212 533 327 1139 373 1960 15 271 7 865 -15
1120 -65 753 -221 1468 -486 2236 -33 97 -70 223 -81 280 -27 134 -30 342 -7
489 31 194 41 418 35 758 -5 299 -4 329 14 400 62 249 255 444 499 507 35 9
117 21 182 26 65 4 146 16 181 25 224 58 394 191 532 415 217 354 454 579 813
772 336 182 565 400 767 731 79 130 87 142 173 230 95 97 204 176 334 240 167
81 260 147 384 270 275 274 405 604 391 991 -3 82 -13 182 -21 220 l-16 70 32
45 c88 125 173 258 241 377 114 199 184 293 243 323 16 8 35 23 42 33 7 9 22
17 32 17 10 0 25 6 32 13 18 17 98 46 188 68 114 29 195 25 335 -15 218 -63
413 -102 665 -132 201 -25 645 -25 855 0 366 42 691 123 1020 253 130 52 434
196 445 212 3 4 20 13 38 20 17 8 32 17 32 22 0 5 6 9 14 9 8 0 21 6 28 14 8
7 24 17 36 20 12 4 22 12 22 17 0 5 7 9 15 9 8 0 15 5 15 10 0 6 6 10 14 10 8
0 16 7 20 15 3 8 15 15 26 15 11 0 20 5 20 10 0 6 6 10 14 10 8 0 16 7 20 15
3 8 12 15 21 15 8 0 15 5 15 10 0 6 4 10 10 10 5 0 20 11 34 25 14 14 32 25
39 25 8 0 17 7 21 15 3 8 11 15 18 15 7 0 19 9 26 20 7 11 18 20 25 20 7 0 18
9 25 20 7 11 17 20 23 20 6 0 20 11 31 25 11 14 24 25 29 25 22 0 422 413 523
540 176 220 391 559 438 689 31 84 30 244 -2 326 -46 119 -137 228 -226 270
-54 25 -132 102 -159 155 -67 131 -46 292 50 399 21 22 43 41 50 41 7 0 15 4
17 8 5 13 101 51 147 58 25 4 54 18 72 35 17 16 36 29 41 29 6 0 19 11 30 25
11 14 23 25 28 25 5 0 35 28 68 63 272 283 420 592 462 964 15 124 3 208 -40
298 -55 113 -165 212 -279 250 -111 37 -170 165 -126 273 18 43 53 82 72 82 7
0 13 4 13 8 0 16 107 35 147 27 70 -14 86 -10 138 38 28 26 53 47 57 47 16 0
133 160 169 232 100 199 114 453 35 647 l-24 59 42 11 c56 17 216 92 216 103
0 4 6 8 14 8 8 0 16 6 19 13 2 7 22 21 42 32 57 30 209 179 280 274 175 233
272 574 220 774 -30 116 -102 219 -193 278 -50 32 -81 70 -200 252 -280 427
-453 920 -513 1457 -14 135 -15 504 0 640 37 339 114 637 246 955 77 184 119
358 156 650 20 152 17 579 -5 740 -117 859 -529 1597 -1190 2131 -44 36 -151
113 -237 170 -86 57 -173 122 -193 144 -106 117 -137 306 -73 444 31 67 91
146 112 146 7 0 15 7 19 15 3 8 12 15 20 15 7 0 16 6 19 14 3 7 21 16 41 19
40 6 226 94 226 107 0 4 11 11 25 14 14 4 25 11 25 16 0 6 7 10 15 10 8 0 15
5 15 10 0 6 6 10 14 10 8 0 16 7 20 15 3 8 12 15 21 15 8 0 15 5 15 10 0 6 8
14 18 17 9 4 25 17 35 30 10 13 24 23 30 24 18 1 180 184 249 280 68 96 165
287 203 402 58 176 69 254 70 492 0 243 -13 334 -77 514 -64 183 -98 239 -250
412 -893 1018 -2012 1807 -3280 2309 -249 99 -421 155 -537 175 l-91 16 -134
103 c-366 282 -748 497 -1211 681 -520 207 -778 375 -1145 744 -102 103 -220
215 -263 250 -277 224 -648 403 -977 471 -181 37 -222 50 -315 95 -315 155
-515 477 -515 830 0 114 18 211 64 346 81 240 118 548 98 812 -34 432 -180
820 -440 1171 -94 127 -297 329 -426 426 -125 93 -317 205 -432 252 -49 21
-123 51 -166 68 -172 70 -377 239 -488 404 -115 172 -168 326 -200 583 -131
1068 -548 2043 -1222 2862 -109 132 -362 405 -417 449 -109 90 -277 322 -366
507 -69 143 -97 222 -150 430 -96 376 -211 640 -393 908 -113 166 -160 247
-193 331 -72 188 -98 365 -78 548 27 250 -28 552 -147 807 l-44 94 327 566
c180 311 335 581 346 599 l20 33 52 -118 c129 -295 282 -529 520 -798 115
-130 167 -201 228 -310 127 -229 169 -460 140 -760 -19 -188 -8 -303 42 -443
50 -138 99 -213 254 -384 677 -749 1561 -1353 2486 -1698 247 -92 362 -157
502 -283 133 -120 224 -240 285 -377 l29 -65 -15 -165 c-57 -605 -9 -1295 130
-1875 21 -87 46 -165 59 -186 34 -53 440 -464 596 -603 345 -309 726 -582
1128 -811 313 -178 489 -235 721 -235 259 0 501 77 712 226 54 38 154 109 223
158 251 176 652 396 828 452 198 63 423 17 580 -117 63 -54 133 -154 168 -240
31 -76 55 -114 169 -265 348 -459 814 -841 1325 -1085 l105 -51 48 16 c85 28
309 143 411 211 280 184 519 430 685 705 59 98 64 120 97 495 31 342 34 993 6
1310 -38 436 -97 819 -182 1189 l-25 109 -63 58 c-44 40 -74 79 -98 126 -33
65 -34 73 -34 178 0 104 2 113 34 179 23 47 55 90 106 140 179 176 386 484
520 771 463 998 374 2151 -238 3065 -176 262 -175 261 -612 568 -285 200 -622
422 -888 587 l-78 48 -232 5 c-387 8 -741 -23 -1132 -100 -185 -36 -227 -41
-350 -41 -205 0 -380 41 -560 130 -318 159 -568 460 -657 794 l-21 77 32 115
c150 540 13 1092 -368 1490 -83 86 -98 98 -120 93 -142 -32 -221 -27 -327 23
-115 54 -234 204 -234 296 0 81 -101 214 -193 255 -176 78 -393 -15 -459 -196
l-11 -31 -236 -7 c-130 -3 -774 -22 -1431 -42 -657 -19 -1357 -36 -1555 -37
l-360 -2 -96 26 c-130 36 -233 81 -334 144 -49 31 -105 58 -135 64 -74 16
-230 13 -313 -5 -100 -22 -245 -94 -323 -160 l-65 -56 28 50 c413 721 880
1522 888 1522 6 0 48 -18 93 -40 104 -51 256 -102 392 -132 92 -20 132 -23
330 -22 214 0 232 1 378 32 134 28 160 31 213 23 127 -21 214 -87 279 -213 76
-145 168 -208 308 -208 87 0 171 38 227 102 22 25 60 55 85 68 117 59 264 192
343 313 52 79 104 192 129 285 18 63 22 106 22 242 1 144 -2 175 -22 244 -74
257 -241 469 -463 589 -35 20 -161 74 -279 122 -526 212 -1037 468 -1520 760
-194 117 -573 370 -740 494 -362 269 -560 377 -816 447 -151 41 -250 55 -420
61 -182 6 -283 -3 -504 -48 -462 -95 -534 -103 -875 -104 -148 0 -333 4 -410
9 -166 10 -245 0 -388 -48 -483 -165 -754 -698 -601 -1180 124 -391 232 -619
415 -877 123 -172 161 -293 139 -434 -6 -37 -15 -77 -21 -87 -14 -26 0 -46
100 -146 117 -117 238 -204 386 -277 239 -119 404 -158 665 -159 143 -1 195 3
285 22 417 83 733 298 986 668 49 73 106 144 125 159 98 75 237 103 349 70
106 -31 138 -56 219 -178 91 -135 199 -260 301 -346 41 -35 75 -68 75 -74 0
-5 -195 -347 -434 -760 -238 -414 -477 -826 -529 -917 -66 -115 -103 -169
-122 -178 -83 -42 -427 -108 -640 -122 -165 -11 -231 -27 -343 -80 -130 -62
-203 -124 -305 -263 -33 -43 -70 -125 -100 -217 -18 -54 -21 -90 -22 -210 0
-163 17 -241 79 -355 32 -59 33 -64 44 -255 12 -199 34 -356 71 -513 l21 -88
-356 -617 c-196 -339 -362 -627 -370 -639 -14 -22 -16 -21 -117 83 -56 59
-139 136 -184 171 -181 142 -266 283 -294 490 -15 112 0 210 53 357 55 152 67
191 83 267 100 469 -139 962 -571 1178 -84 42 -203 83 -294 101 l-55 10 -34
98 c-172 500 -473 1144 -774 1657 -334 568 -807 1203 -1226 1645 -257 270
-458 666 -535 1055 -65 325 -61 608 14 944 43 188 54 315 41 448 -39 383 -246
711 -571 904 -248 147 -1152 1039 -1601 1579 -85 102 -97 122 -109 175 -108
495 -362 1045 -685 1481 -164 221 -401 476 -596 640 l-81 69 6 60 c3 33 9 265
12 515 9 591 -10 963 -76 1500 -24 192 -94 628 -115 715 -8 33 -28 125 -45
205 -42 200 -126 536 -162 650 -56 174 -132 301 -255 423 -237 234 -548 335
-878 282z m-33373 -92015 c92 -157 167 -290 167 -296 1 -7 -75 -142 -168 -300
l-168 -289 -344 -3 -344 -2 -165 286 c-91 158 -166 293 -168 300 -2 6 72 143
164 303 l167 291 346 -2 345 -3 168 -285z"/>
                        <Square
                            size={1000}
                            cx={60000}
                            cy={50000}
                            stroke="red"
                            strokeWidth={1}
                            fill="#29C58D"
                            onClick={(e) => alert('2X2 land(for sale)')}
                        />
                        <Square
                            size={2000}
                            cx={50000}
                            cy={50000}
                            stroke="red"
                            strokeWidth={1}
                            fill="#AD6F4C"
                            onClick={(e) => alert('4X4 land(premium)')}
                        />
                        {/*<image*/}
                        {/*    overflow="visible"*/}
                        {/*    href="https://www.iconinc.co.uk/assets/img/floorplans/gravity/0.jpg"*/}
                        {/*    className={'brand'}*/}
                        {/*/>*/}

                    </g>


                </svg>
            </ReactSVGPanZoom>
        </div>
    )
}

export default SvgMap2;